import React from 'react';
import authenticator from 'authenticator';
import { QRCodeCanvas } from 'qrcode.react';
import PropTypes from 'prop-types';
const genertateSecretURL = (username, customer, secret) => {
  const label = `${username}@${customer}`;
  return authenticator.generateTotpUri(secret, label, 'TRU');
};
const QRCode = ({
  username,
  customer,
  secret
}) => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QRCodeCanvas, {
  size: 256,
  value: genertateSecretURL(username, customer, secret)
}), /*#__PURE__*/React.createElement("span", {
  style: {
    display: 'none'
  },
  id: secret.replace(/ /g, ''),
  className: "t-secret-value"
}));
QRCode.propTypes = {
  username: PropTypes.string.isRequired,
  customer: PropTypes.string.isRequired,
  secret: PropTypes.string.isRequired
};
export default QRCode;